import { createAsyncThunk } from "@reduxjs/toolkit";
import { multitenantRoutes } from "../../../Constants/api";
import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequest,
} from "Utilities/ApiHelpers/ApiHelpers.index";
import { IUser } from "./types";

export const getAllUsers = createAsyncThunk(
  multitenantRoutes.getOrganizations,
  async () => {
    const response = await getRequest(multitenantRoutes.GetAllUsers);
    return response.data;
  }
);

export const addUser = createAsyncThunk(
  multitenantRoutes.organizations,
  async (user: IUser) => {
    const response = await postRequest(
      multitenantRoutes.AddUser,
      null,
      true,
      user,
      null
    );
    return response.data;
  }
);

export const updateUser = createAsyncThunk(
  multitenantRoutes.organizations,
  async (user: IUser) => {
    const response = await putRequest(
      multitenantRoutes.updateUser,
      null,
      true,
      user,
      null
    );
    return response.data;
  }
);

export const deleteUser = createAsyncThunk(
  multitenantRoutes.deleteUser,
  async (user: IUser) => {
    const response = await deleteRequest(
      multitenantRoutes.deleteUser,
      null,
      true,
      user
    );
    return response.data;
  }
);
